import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

function SchemeCreation() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [durations, setDurations] = useState([]);
  const [isIntervalModalOpen, setIsIntervalModalOpen] = useState(false);
  const [intervals, setIntervals] = useState("");
  const [duration, setDuration] = useState("");
  const [num, setNum] = useState("");
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [touched, setTouched] = useState({
    scheme_id: false,
    scheme_name: false,
    description: false,
    interval_detail: false,
    statuss: false,
  });
  const [formData, setFormData] = useState({
    scheme_id: "",
    scheme_name: "",
    description: "",
    interval_detail: "",
    duration: "",
    statuss: "",
    num: "",
  });

  const handleAddIntervalClick = () => {
    setIsIntervalModalOpen(!isIntervalModalOpen);
  };

  const updateData = (id) => {
    const item = items.find((item) => item.id === id);
    if (item) {
      setFormData({
        scheme_id: item.scheme_id,
        scheme_name: item.scheme_name,
        description: item.description,
        interval_detail: item.interval_detail,
        duration: item.duration,
        num: item.num,
        statuss: item.statuss,

        id: item.id,
      });
      console.log("Updating data for Assign Account:", item);
      setIsEditMode(true);
      setIsModalOpen(true);
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setTouched({
      scheme_id: false,
      scheme_name: false,
      description: false,
      interval_detail: false,
      statuss: false,
    });
    if (!isModalOpen && !isEditMode) {
      const emptyData = {
        scheme_id: "",
        scheme_name: "",
        description: "",
        interval_detail: "",
        duration: "",
        num: "",
        statuss: "",
      };

      setFormData(emptyData);
      setErrors({});
    }
  };

  const validateField = (name, value) => {
    let error = "";

    if (name === "scheme_id" && !value) {
      error = "Required";
    }

    if (name === "scheme_name" && !value) {
      error = "Required";
    }
    if (name === "interval_detail" && !value) {
      error = "Required";
    }

    return error;
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/getAllScheme`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const handleDelete = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem(item.id);
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The scheme has been deleted.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  const handleIntervalChange = async (e) => {
    console.log("handleIntervalChange called", e.target.value);
    const selectedInterval = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      interval_detail: selectedInterval,
      duration: "",
      num: "",
    }));

    const selectedDuration = durations.find(
      (duration) =>
        duration.intervals.trim().toLowerCase() ===
        selectedInterval.trim().toLowerCase()
    );

    if (selectedDuration) {
      console.log("Selected Interval:", selectedDuration);
      setFormData((prevData) => ({
        ...prevData,
        duration: selectedDuration.duration,
        num: selectedDuration.num,
      }));
    }
  };
  const deleteItem = async (id) => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.delete(`${baseURL}/deleteScheme`, {
        data: { id: id },
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });

      if (response.status === 200) {
        fetchItems();
      } else {
        Swal.fire({
          icon: "error",
          title: "Deletion Failed",

          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setTouched((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, value),
    }));
  };

  const handleDropdownClick = () => {
    const accessToken = sessionStorage.getItem("access_token");
    axios
      .get(`${baseURL}/getAllIntervalDuration`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setDurations(response.data);
      });
  };

  const handleIntervalSubmit = async () => {
    const formData = { intervals, duration, num };
    console.log(formData);
    if (!intervals || !duration || !num) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Form",
        text: "Please fill all the fields.",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.post(`${baseURL}/insertIntervalDuration`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });

      Swal.fire({
        icon: "success",
        text: "Interval added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      setIntervals("");
      setDuration("");
      setNum("");
      handleAddIntervalClick();
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitted(true);

    setTouched({
      scheme_id: true,
      scheme_name: true,
      description: true,
      interval_detail: true,
      statuss: true,
    });
    console.log("Form submission started");
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }
    console.log("Validation errors:", newErrors);
    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      console.log("Form validation failed. Submission aborted.");
      return;
    }

    const isDuplicate = items.some(
      (item) =>
        item.scheme_id === formData.scheme_id ||
        item.scheme_name === formData.scheme_name
    );

    if (isDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Duplicate Scheme ID or Scheme Name detected!",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.post(`${baseURL}/insertScheme`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });
      Swal.fire({
        icon: "success",
        text: "Scheme added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      toggleModal();
      fetchItems();
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const handleEdit = async () => {
    console.log("Form Data before update:", formData);
    setIsSubmitted(true);
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }
    const isDuplicate = items.some(
      (item) =>
        (item.scheme_id === formData.scheme_id ||
          item.scheme_name === formData.scheme_name) &&
        item.id !== formData.id
    );

    if (isDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Duplicate Scheme ID or Scheme Name detected!",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.put(`${baseURL}/updateScheme`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`, 
          
        },
      });

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Scheme updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
        fetchItems();
        toggleModal();
        setIsEditMode(false);
      } else {
        console.error("Error updating account:", response.data);
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const filteredItems = items.filter(
    (item) =>
      item.scheme_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.scheme_id.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="bg-gray-100 flex flex-col w-full">
      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">Scheme Creation</h2>

        {/* Table */}
        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0 mb-4">
            <div className="flex items-center space-x-2">
              <label className="md:text-sm">Show</label>
              <select
                className="border border-gray-300 rounded p-1"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option className="md:text-xs" value="10">
                  10
                </option>
                <option className="md:text-xs" value="25">
                  25
                </option>
                <option className="md:text-xs" value="50">
                  50
                </option>
              </select>
              <span>entries</span>
            </div>
            <div className="flex items-center space-x-4 overflow-y-auto">
              <button
                onClick={() => {
                  setIsEditMode(false);
                  toggleModal();
                }}
                className="bg-green-500 text-white px-4 py-2 rounded w-full sm:w-auto"
              >
                Add Scheme
              </button>
              {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="relative w-full sm:w-full md:w-1/2 max-h-[70vh] overflow-y-auto bg-white rounded-lg p-4 top-12 sm:top-16 md:top-24">
                    <div className="flex justify-between items-center mb-4">
                      <h2 className="text-lg md:text-xl font-semibold">
                        {isEditMode ? "Update Scheme" : "Add Scheme"}
                      </h2>
                      <button
                        onClick={() => {
                          setIsEditMode(false);
                          toggleModal();
                        }}
                        className="text-gray-600 text-2xl"
                      >
                        &times;
                      </button>
                    </div>
                    <div className="max-h-[70vh] overflow-y-auto p-2">
                      <form className="space-y-4">
                        <div className="flex flex-col items-center mb-6"></div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className="block text-gray-600">
                              Scheme ID <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="scheme_id"
                              value={formData.scheme_id || ""}
                              onChange={handleInputChange}
                              placeholder="Enter an id for the scheme "
                              className={`placeholder:text-sm border p-2 w-full ${
                                errors.scheme_id && touched.scheme_id
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                            />
                            {errors.scheme_id && touched.scheme_id && (
                              <span className="text-red-500 text-sm">
                                {errors.scheme_id}
                              </span>
                            )}
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Scheme Name <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="scheme_name"
                              value={formData.scheme_name || ""}
                              onChange={handleInputChange}
                              placeholder="Enter scheme name(Eg.Daily Collection) "
                              className={`placeholder:text-sm border p-2 w-full ${
                                errors.scheme_name && touched.scheme_name
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                            />
                            {errors.scheme_name && touched.scheme_name && (
                              <span className="text-red-500 text-sm">
                                {errors.scheme_name}
                              </span>
                            )}
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Description
                            </label>
                            <input
                              type="text"
                              name="description"
                              value={formData.description || ""}
                              placeholder="Provide a description for the scheme"
                              onChange={handleInputChange}
                              className={`placeholder:text-sm border p-2 w-full border-gray-300
                              `}
                            />
                            {errors.description && touched.description && (
                              <span className="text-red-500 text-sm">
                                {errors.description}
                              </span>
                            )}
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Interval <span className="text-red-500">*</span>
                            </label>
                            <div className="relative">
                              <select
                                name="interval_detail"
                                value={formData.interval_detail || ""}
                                onClick={handleDropdownClick}
                                onChange={(e) => {
                                  handleInputChange(e);
                                  handleIntervalChange(e);
                                }}
                                className={`border p-2 w-3/4 ${
                                  errors.interval_detail &&
                                  touched.interval_detail
                                    ? "border-red-500"
                                    : "border-gray-300"
                                }`}
                              >
                                <option value="">Select the Interval</option>
                                {durations.length > 0 ? (
                                  durations.map((duration) => (
                                    <option
                                      key={duration.intervals}
                                      value={duration.intervals}
                                    >
                                      {duration.intervals}
                                    </option>
                                  ))
                                ) : (
                                  <option disabled>No values available</option>
                                )}
                              </select>
                              {errors.interval_detail &&
                                touched.interval_detail && (
                                  <span className="text-red-500 text-sm">
                                    {errors.interval_detail}
                                  </span>
                                )}
                              <div>
                                <button
                                  type="button"
                                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500 font-bold bg-blue-500 text-white rounded-full p-2 shadow-md hover:bg-blue-600"
                                  onClick={handleAddIntervalClick}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                            {isIntervalModalOpen && (
                              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                                <div className="bg-white p-4  w-full sm:w-1/2 md:w-1/3 mx-4 rounded-lg ">
                                  <h2 className="text-lg font-semibold mb-4">
                                    Add Interval
                                  </h2>
                                  <form>
                                    <div className="mb-4">
                                      <label className="block text-sm font-medium">
                                        Interval<span className="text-red-500">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-input w-full"
                                        placeholder="Eg:For Monthly collection : 30 days"
                                        value={intervals}
                                        onChange={(e) =>
                                          setIntervals(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-4">
                                      <label className="block text-sm font-medium">
                                        Duration<span className="text-red-500">*</span>
                                      </label>
                                      <input
                                        type="number"
                                        className="form-input w-full"
                                        placeholder="Eg:For Monthly collection : 6 (No.of months)"
                                        name="duration"
                                        value={duration}
                                        onChange={(e) =>
                                          setDuration(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-4">
                                      <label className="block text-sm font-medium">
                                        Value<span className="text-red-500">*</span>
                                      </label>
                                      <input
                                        type="number"
                                        placeholder="Eg:For Monthly collection : 30 "
                                        className="form-input w-full"
                                        value={num}
                                        onChange={(e) => setNum(e.target.value)}
                                      />
                                    </div>
                                    <div className="flex justify-end space-x-4">
                                      <button
                                        type="button"
                                        className="px-4 py-2 bg-gray-300 rounded-md"
                                        onClick={handleAddIntervalClick}
                                      >
                                        Close
                                      </button>
                                      <button
                                        type="button"
                                        onClick={handleIntervalSubmit}
                                        className="px-4 py-2 bg-blue-500 text-white rounded-md"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            )}
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Duration <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="duration"
                              value={formData.duration || ""}
                              className="border border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-600">Value<span className="text-red-500">*</span></label>
                            <input
                              type="text"
                              name="num"
                              value={formData.num || ""}
                              className="border border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          {isEditMode && (
                          <div>
                            <label className="block text-gray-600">
                              Status
                            </label>
                            <select
                              name="statuss"
                              value={formData.statuss || ""}
                              onChange={handleInputChange}
                              className="border p-2 w-full border-gray-300"
                            >
                              <option>Mark the status</option>
                              <option>Active</option>
                              <option>Inactive</option>
                            </select>
                          </div>
                        )}
                          
                        </div>
                        <div className="flex justify-end space-x-4 mt-4">
                         
                          <button
                            type="button"
                            onClick={() => {
                              toggleModal();
                              setIsEditMode(false);
                            }}
                            className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                          >
                            Close
                          </button>
                          <button
                            onClick={() => {
                              if (isEditMode) {
                                handleEdit();
                              } else {
                                handleSubmit();
                                setIsEditMode(false);
                              }
                            }}
                            type="button"
                            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                          >
                            {isEditMode ? "Update" : "Submit"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  placeholder="Search"
                  className="border border-gray-300 rounded p-1 w-full sm:w-auto"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Table Content */}
          <div className="flex flex-col h-screen">
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2">Id</th>
                    <th className="p-2">Scheme ID</th>
                    <th className="p-2">Scheme Name</th>
                    <th className="p-2">Description</th>
                    <th className="p-2">Interval</th>
                    <th className="p-2">Duration</th>
                    <th className="p-2">Value</th>
                    <th className="p-2">Status</th>
                    <th className="p-2">Option</th>
                  </tr>
                </thead>

                <tbody>
                  {currentItems.map((item) => (
                    <tr key={item.id} className="border-b">
                      <td className="p-2">{item.id || "--"}</td>
                      <td className="p-2">{item.scheme_id  || "--"}</td>
                      <td className="p-2">{item.scheme_name  || "--" }</td>
                      <td className="p-2">{item.description  || "--" }</td>
                      <td className="p-2">{item.interval_detail  || "--" }</td>
                      <td className="p-2">{item.duration  || "--"}</td>
                      <td className="p-2">{item.num  || "--"}</td>
                      <td className="p-2">{item.statuss  || "--"}</td>

                      <td className="p-2 space-x-3">
                        <button
                          onClick={() => updateData(item.id)}
                          className="text-blue-500"
                        >
                          <i className="fas fa-edit"></i>
                        </button>

                        <button
                          onClick={() => handleDelete(item)}
                          className="text-red-500"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination Controls */}
              <div className="flex justify-between items-center mt-4">
                <p>
                  Showing {indexOfFirstItem + 1} to{" "}
                  {indexOfLastItem > items.length
                    ? items.length
                    : indexOfLastItem}{" "}
                  of {items.length} entries
                </p>
                <div className="flex space-x-2">
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                  {[...Array(totalPages).keys()].map((num) => (
                    <button
                      key={num}
                      className={`border px-2 py-1 rounded ${
                        currentPage === num + 1 ? "bg-blue-500 text-white" : ""
                      }`}
                      onClick={() => handlePageChange(num + 1)}
                    >
                      {num + 1}
                    </button>
                  ))}
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default SchemeCreation;
